import { render, staticRenderFns } from "./GoodReceiveViewEdit.vue?vue&type=template&id=04e39aaa&scoped=true&"
import script from "./GoodReceiveViewEdit.vue?vue&type=script&lang=js&"
export * from "./GoodReceiveViewEdit.vue?vue&type=script&lang=js&"
import style0 from "./GoodReceiveViewEdit.vue?vue&type=style&index=0&id=04e39aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e39aaa",
  null
  
)

export default component.exports